<h1 *ngIf="data.type == 'conoscenze'" mat-dialog-title>CREAZIONE
  CONOSCENZE<mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon></h1>
<h1 *ngIf="data.type == 'abilita'" mat-dialog-title>CREAZIONE
  ABILITA'<mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon></h1>

<div class="form-container">
  <form class="details-form">
    <mat-form-field class="half-width-textarea margin-right">
      <mat-label>Descrizione*</mat-label>
      <textarea rows="5" matInput placeholder="Descrizione"
                name="descrizione" [(ngModel)]="descrizione"></textarea>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onNoClick()">
    <mat-icon>close</mat-icon>Annulla
  </button>
  <button mat-fab extended class="searchbox-buttons save-button" (click)="save()" [disabled]="descrizione.length == 0">
    <mat-icon>compare_arrows</mat-icon>Crea
  </button>
</div>
